import {Injectable} from "@angular/core";
import {ApiClient} from "../../../tools/api-client";
import {Observable} from "rxjs/internal/Observable";
import {MeasurementType} from "../../measurement-models";

export interface HospitalMeasurementTypes {
  types: MeasurementType[];
  homeTypes: MeasurementType[];
}

@Injectable()
export class HospitalMeasurementTypesService {

  constructor(private readonly apiClient: ApiClient) {
  }

  getOwnHospitalMeasurementTypes(): Observable<HospitalMeasurementTypes> {
    return this.apiClient.get<HospitalMeasurementTypes>("/api/hospitals/allowed-types");
  }
}
